/**
 * Carousel Component
 * @module patterns/components/carousels/offers-tile-and-carousel
 */
import Glide from '@glidejs/glide';

import { type App } from '~/app';

// eslint-disable-next-line import/no-unresolved

export const CAROUSELS: Glide[] = [];

export default (app: App) => {

    app.afterMount
        .then(() => {
            mountOffersTileCarousel()
        })
        .catch((error: ErrorOptions | undefined) => {
            throw new Error('[Stockland FE] Unable to register Stockland Offers Tile and Carousel component', error);
        });

    return function destroyFeaturedCarousel() {
        while (CAROUSELS.length > 0) {
            const c = CAROUSELS.pop();
            if (c) {
                c.destroy();
            }
        }

        app.logger.debug('[DXA] Offers Tile and Carousel component destroyed');
    };
}

export function mountOffersTileCarousel() {
    const offerTilesCarouselComponents = document.querySelectorAll<HTMLElement>('.offers-tile-and-carousel');
    for (const carousel of offerTilesCarouselComponents) {

        const carouselGlide = new Glide(carousel, {
            type:'carousel',
            perView: 1,
            focusAt: 0,
            gap: 32,
            peek:340,
            breakpoints:{
                767: {
                    peek:0,
                    focusAt: 0,
                    perView: 1,

                },
                1024: {
                    peek:120,
                    focusAt: 0,
                    perView: 1,

                },
                1280:{
                    peek:240,
                    focusAt: 0,
                    perView: 1,

                },
                1441: {
                    peek:340,
                    focusAt: 0,
                    perView: 1,

                }
            }
        });

        setTimeout(() => {
            // Timeout to load clone slides
            carouselGlide.mount();
        }, 800);
        CAROUSELS.push(carouselGlide as Glide);
    }
    
}